import { IWindow } from '@/interfaces/Window';
import { verifyCaptchaEndpoint } from '@/api/microsservices/CommerceApi';
import { EPaymentMethodTypes } from './enums';

const siteKey = process.env.VUE_APP_CAPTCHA_SITE_KEY;

export function createCaptcha(): Promise<any> {
  return new Promise((resolve: any, reject: any) => {
    try {
      const loadedCaptcha = (): any => {
        if ((window as unknown as IWindow).grecaptcha) {
          (window as unknown as IWindow).grecaptcha.ready(() => resolve());
        }
      };

      const recaptcha = document.createElement('script');
      recaptcha.setAttribute('src', `https://www.google.com/recaptcha/api.js?render=${siteKey}`);
      recaptcha.defer = true;
      recaptcha.onload = loadedCaptcha;

      document.head.appendChild(recaptcha);
    } catch (err) {
      reject(err);
    }
  });
}

export function executeCaptcha(action?: string|EPaymentMethodTypes): Promise<any> {
  return new Promise((resolve: any, reject: any) => {
    try {
      if ((window as unknown as IWindow).grecaptcha) {
        (window as unknown as IWindow).grecaptcha.execute(siteKey, { action })
          .then((token: any) => {
            verifyCaptchaEndpoint.post({ response: token })
              .then((res: any) => resolve(res.data.success));
          });
      }
    } catch (err) {
      reject(err);
    }
  });
}